import { Component } from '@angular/core';

@Component({
  selector: 'spin-box-specs',
  templateUrl: './spin-box-specs.component.html',
  styleUrls: ['./spin-box-specs.component.sass']
})
export class SpinBoxSpecsComponent {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/spinbox/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
